<div class="h-full flex flex-col bg-white">
  <!-- ==================== HEADER ==================== -->
  <div class="px-6 py-4 border-b border-gray-200 flex-shrink-0">
    <div class="flex items-center justify-between">
      <!-- Título -->
      <div class="flex-1">
        <h2 class="text-lg font-semibold text-gray-900">
          <span *ngIf="esModoCargar">Cargar Nuevo Paraclínico</span>

          <!-- Título editable para paraclínicos existentes -->
          <span *ngIf="!esModoCargar && paraclinicoSeleccionado && !editandoTitulo" class="flex items-center gap-2">
            <span>{{ paraclinicoSeleccionado.nombre || 'Paraclínico' }}</span>
            <button
              type="button"
              class="p-1 text-gray-400 hover:text-[#AE91E3] hover:bg-purple-50 rounded transition"
              (click)="iniciarEdicionTitulo()"
              title="Editar título"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" />
              </svg>
            </button>
          </span>

          <!-- Input para editar título -->
          <span *ngIf="!esModoCargar && paraclinicoSeleccionado && editandoTitulo" class="flex items-center gap-2">
            <input
              type="text"
              [(ngModel)]="tituloEditado"
              class="px-2 py-1 border border-purple-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:outline-none text-base"
              (keydown.enter)="guardarTitulo()"
              (keydown.escape)="cancelarEdicionTitulo()"
              autofocus
            />
            <button
              type="button"
              class="p-1 text-green-500 hover:text-green-700 hover:bg-green-50 rounded transition"
              (click)="guardarTitulo()"
              title="Guardar"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
            </button>
            <button
              type="button"
              class="p-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded transition"
              (click)="cancelarEdicionTitulo()"
              title="Cancelar"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </span>

          <span *ngIf="!esModoCargar && !paraclinicoSeleccionado">Selecciona un paraclínico</span>
        </h2>
        <p class="text-sm text-gray-500 mt-1" *ngIf="!esModoCargar && paraclinicoSeleccionado">
          {{ paraclinicoSeleccionado.fecha | date : 'dd/MM/yyyy' }}
        </p>
      </div>

      <!-- ==================== BOTONES PARA MODO CARGAR ==================== -->
      <div class="flex items-center gap-3" *ngIf="esModoCargar">
        <button
          type="button"
          class="px-5 py-2.5 rounded-lg text-sm font-semibold bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
          (click)="cancelarEdicion()"
          [disabled]="guardando"
        >
          Cancelar
        </button>
        <button
          type="button"
          class="px-5 py-2.5 rounded-lg text-sm font-semibold bg-[#AE91E3] text-white hover:bg-[#9b7cd1] transition"
          (click)="guardar()"
          [disabled]="guardando"
        >
          {{ guardando ? 'Guardando...' : 'Guardar Paraclínico' }}
        </button>
      </div>

      <!-- ==================== TABS Y BOTONES PARA MODO VER/EDITAR ==================== -->
      <div class="flex items-center gap-4" *ngIf="!esModoCargar && paraclinicoSeleccionado">
        <!-- Tabs PDF / TABLA -->
        <div class="flex items-center gap-2">
          <button
            type="button"
            [class]="
              tabActiva === 'pdf'
                ? 'px-4 py-2 rounded-lg text-sm font-semibold bg-[#AE91E3] text-white'
                : 'px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100'
            "
            (click)="cambiarTab('pdf')"
          >
            PDF
          </button>
          <!-- Tab TABLA solo visible para laboratorios -->
          <button
            type="button"
            *ngIf="esLaboratorio"
            [class]="
              tabActiva === 'tabla'
                ? 'px-4 py-2 rounded-lg text-sm font-semibold bg-[#AE91E3] text-white'
                : 'px-4 py-2 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-100'
            "
            (click)="cambiarTab('tabla')"
          >
            TABLA
          </button>
        </div>

        <!-- Botones Cancelar/Guardar (solo en modo editar) -->
        <div class="flex items-center gap-3" *ngIf="!esVistaLectura">
          <button
            type="button"
            class="px-4 py-2 rounded-lg text-sm font-semibold bg-gray-200 text-gray-700 hover:bg-gray-300 transition"
            (click)="cancelarEdicion()"
          >
            Cancelar
          </button>
          <button
            type="button"
            class="px-4 py-2 rounded-lg text-sm font-semibold bg-[#AE91E3] text-white hover:bg-[#9b7cd1] transition"
            (click)="guardar()"
            [disabled]="guardando"
          >
            {{ guardando ? 'Guardando...' : 'Guardar Cambios' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ==================== CONTENIDO ==================== -->
  <div class="flex-1 overflow-y-auto scrollbar-thin">
    <!-- ==================== VISTA: SIN SELECCIÓN ==================== -->
    <div *ngIf="!esModoCargar && !paraclinicoSeleccionado" class="h-full flex items-center justify-center">
      <div class="text-center text-gray-400">
        <svg class="w-20 h-20 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        <p class="text-base font-medium mb-2">No hay paraclínico seleccionado</p>
        <p class="text-sm">Selecciona uno de la lista o haz clic en "Nuevo"</p>
      </div>
    </div>

    <!-- ==================== VISTA: CARGAR NUEVO ==================== -->
    <div *ngIf="esModoCargar" class="p-6 space-y-6">
      <!-- Fila: Tipo, Nombre, Fecha, Archivo -->
      <div class="grid grid-cols-4 gap-4">
        <!-- Tipo -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Tipo de estudio *</label>
          <select
            [(ngModel)]="formulario.tipo"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 bg-white"
          >
            <option [value]="undefined" disabled selected>Seleccionar</option>
            <option value="interno">Estudio Interno</option>
            <option value="laboratorio">Estudio de Laboratorio</option>
            <option value="gabinete">Estudio de Gabinete</option>
          </select>
        </div>

        <!-- Nombre -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Nombre del estudio</label>
          <input
            type="text"
            [(ngModel)]="formulario.nombre"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
            placeholder="Ej: Biometría hemática"
          />
        </div>

        <!-- Fecha -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Fecha del estudio</label>
          <input
            type="date"
            [(ngModel)]="formulario.fecha"
            class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500"
          />
        </div>

        <!-- Archivos -->
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">Archivos (PDF o Imagen) *</label>
          <input
            type="file"
            accept="application/pdf,image/png,image/jpeg,image/jpg"
            (change)="onArchivoChange($event)"
            class="hidden"
            id="fileInput"
            multiple
          />
          <label
            for="fileInput"
            class="w-full px-3 py-2 rounded-lg text-sm font-semibold bg-[#AE91E3] text-white hover:bg-[#9b7cd1] transition cursor-pointer flex items-center justify-center gap-2"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
            </svg>
            Agregar archivos
          </label>
          <span *ngIf="archivosSeleccionados.length > 0" class="text-xs text-gray-600 mt-1 block">
            {{ archivosSeleccionados.length }} archivo(s) seleccionado(s)
          </span>
        </div>
      </div>

      <!-- Lista de archivos seleccionados -->
      <div *ngIf="archivosSeleccionados.length > 0" class="flex flex-wrap gap-2">
        <div
          *ngFor="let archivo of archivosPreview; let i = index"
          class="flex items-center gap-2 px-3 py-2 bg-gray-100 rounded-lg group"
        >
          <svg *ngIf="!archivo.esImagen" class="w-5 h-5 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
          </svg>
          <svg *ngIf="archivo.esImagen" class="w-5 h-5 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          <span class="text-sm text-gray-700 max-w-[150px] truncate">{{ archivo.file?.name || 'Archivo' }}</span>
          <button
            type="button"
            class="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded transition opacity-0 group-hover:opacity-100"
            (click)="eliminarArchivoPreview(i)"
            title="Eliminar archivo"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>

      <!-- Interpretación -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Interpretación</label>
        <div
          class="border border-gray-300 rounded-lg overflow-hidden quill-container"
          [class.border-purple-500]="!esVistaLectura"
          [class.cursor-pointer]="esVistaLectura"
          [class.hover:border-purple-400]="esVistaLectura"
        >
          <quill-editor
            [(ngModel)]="formulario.interpretacion"
            [readOnly]="esVistaLectura"
            [modules]="quillModules"
            placeholder="Sin interpretación disponible..."
            (onEditorCreated)="onEditorCreated($event)"
            (click)="activarEdicionAlClick()"
            spellcheck="true"
          ></quill-editor>
        </div>
        <p class="text-xs text-gray-500 mt-1" *ngIf="esVistaLectura">Haz clic para editar</p>
      </div>

      <!-- Vista previa del documento -->
      <div>
        <div class="flex items-center justify-between mb-2">
          <label class="block text-sm font-medium text-gray-700">
            Vista previa {{ archivosPreview.length > 1 ? '(' + (archivoVisualizadoIndex + 1) + '/' + archivosPreview.length + ')' : '' }}
          </label>
          <!-- Navegación entre archivos -->
          <div *ngIf="archivosPreview.length > 1" class="flex items-center gap-2">
            <button
              type="button"
              class="p-1.5 rounded-lg text-gray-600 hover:bg-gray-100 transition disabled:opacity-40"
              [disabled]="archivoVisualizadoIndex === 0"
              (click)="navegarArchivo('anterior')"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <span class="text-sm text-gray-600">{{ archivoVisualizadoIndex + 1 }} / {{ archivosPreview.length }}</span>
            <button
              type="button"
              class="p-1.5 rounded-lg text-gray-600 hover:bg-gray-100 transition disabled:opacity-40"
              [disabled]="archivoVisualizadoIndex === archivosPreview.length - 1"
              (click)="navegarArchivo('siguiente')"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
        <div *ngIf="archivosPreview.length > 0" class="border rounded-lg overflow-hidden">
          <!-- Si es imagen, mostrar con <img> -->
          <img
            *ngIf="archivosPreview[archivoVisualizadoIndex]?.esImagen"
            [src]="archivosPreview[archivoVisualizadoIndex].url"
            class="w-full max-h-[500px] object-contain bg-gray-100"
            alt="Vista previa de imagen"
          />

          <!-- Si es PDF, mostrar con <iframe> -->
          <iframe
            *ngIf="!archivosPreview[archivoVisualizadoIndex]?.esImagen"
            [src]="archivosPreview[archivoVisualizadoIndex].url"
            class="w-full h-[500px]"
          ></iframe>
        </div>
        <div
          *ngIf="archivosPreview.length === 0"
          class="border-2 border-dashed border-gray-300 rounded-lg h-[500px] flex items-center justify-center"
        >
          <div class="text-center text-gray-400">
            <svg class="w-16 h-16 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
            <p class="text-sm">Selecciona un archivo para ver la vista previa</p>
          </div>
        </div>
      </div>

      <!-- Error -->
      <div *ngIf="error" class="p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
        {{ error }}
      </div>
    </div>

    <!-- ==================== VISTA: VER PARACLÍNICO - TAB PDF ==================== -->
    <div *ngIf="!esModoCargar && paraclinicoSeleccionado && tabActiva === 'pdf'" class="p-6 space-y-4">
      <!-- Interpretación -->
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Interpretación</label>
        <div
          class="border border-gray-300 rounded-lg overflow-hidden quill-container"
          [class.border-purple-500]="!esVistaLectura"
          [class.cursor-pointer]="esVistaLectura"
          [class.hover:border-purple-400]="esVistaLectura"
          (click)="activarEdicionAlClick()"
        >
          <quill-editor
            [(ngModel)]="formulario.interpretacion"
            [readOnly]="esVistaLectura"
            [modules]="quillModules"
            placeholder="Sin interpretación disponible..."
            (onEditorCreated)="onEditorCreated($event)"
            spellcheck="true"
          ></quill-editor>
        </div>
        <p class="text-xs text-gray-500 mt-1" *ngIf="esVistaLectura">Haz clic para editar</p>
      </div>

      <!-- Documento (PDF o Imagen) -->
      <div>
        <div class="flex items-center justify-between mb-2">
          <label class="block text-sm font-medium text-gray-700">
            {{ etiquetaDocumento }} {{ archivosPreview.length > 1 ? '(' + (archivoVisualizadoIndex + 1) + '/' + archivosPreview.length + ')' : '' }}
          </label>
          <!-- Navegación entre archivos -->
          <div *ngIf="archivosPreview.length > 1" class="flex items-center gap-2">
            <button
              type="button"
              class="p-1.5 rounded-lg text-gray-600 hover:bg-gray-100 transition disabled:opacity-40"
              [disabled]="archivoVisualizadoIndex === 0"
              (click)="navegarArchivo('anterior')"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
              </svg>
            </button>
            <span class="text-sm text-gray-600">{{ archivoVisualizadoIndex + 1 }} / {{ archivosPreview.length }}</span>
            <button
              type="button"
              class="p-1.5 rounded-lg text-gray-600 hover:bg-gray-100 transition disabled:opacity-40"
              [disabled]="archivoVisualizadoIndex === archivosPreview.length - 1"
              (click)="navegarArchivo('siguiente')"
            >
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Vista cuando hay archivos -->
        <div *ngIf="archivosPreview.length > 0" class="border rounded-lg overflow-hidden">
          <!-- Si es imagen, mostrar con <img> -->
          <img
            *ngIf="archivosPreview[archivoVisualizadoIndex]?.esImagen"
            [src]="archivosPreview[archivoVisualizadoIndex].url"
            class="w-full max-h-[600px] object-contain bg-gray-100"
            alt="Imagen del estudio"
          />

          <!-- Si es PDF, mostrar con <iframe> -->
          <iframe
            *ngIf="!archivosPreview[archivoVisualizadoIndex]?.esImagen"
            [src]="archivosPreview[archivoVisualizadoIndex].url"
            class="w-full h-[600px]"
          ></iframe>
        </div>

        <!-- Vista cuando no hay documento -->
        <div
          *ngIf="archivosPreview.length === 0"
          class="border-2 border-dashed border-gray-300 rounded-lg h-[600px] flex items-center justify-center"
        >
          <div class="text-center text-gray-400">
            <svg class="w-16 h-16 mx-auto mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
            <p class="text-sm">No hay documento disponible</p>
          </div>
        </div>
      </div>
    </div>

    <!-- ==================== VISTA: VER PARACLÍNICO - TAB TABLA ==================== -->
    <div *ngIf="!esModoCargar && paraclinicoSeleccionado && tabActiva === 'tabla'" class="p-6">
      <!-- CASO 1: No es tipo laboratorio -->
      <div
        *ngIf="!esLaboratorio"
        class="border-2 border-dashed border-gray-300 rounded-lg h-[600px] flex items-center justify-center"
      >
        <div class="text-center text-gray-400">
          <svg class="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <p class="text-base font-medium mb-2">Función no disponible</p>
          <p class="text-sm">Esta funcionalidad solo está disponible para estudios de laboratorio</p>
        </div>
      </div>

      <!-- CASO 2: ES LABORATORIO -->
      <div *ngIf="esLaboratorio">
        <!-- ESTADO 1: Uploader inicial -->
        <div *ngIf="deberMostrarUploader" class="laboratorio-uploader">
          <div class="bg-gradient-to-br from-purple-50 to-white border-2 border-purple-200 rounded-xl p-8">
            <div class="text-center mb-6">
              <div class="inline-flex items-center justify-center w-16 h-16 bg-purple-100 rounded-full mb-4">
                <svg class="w-8 h-8 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"
                  />
                </svg>
              </div>
              <h3 class="text-xl font-bold text-gray-800 mb-2">📊 Análisis de Laboratorio</h3>
              <p class="text-sm text-gray-600">Este estudio no ha sido analizado automáticamente</p>
            </div>

            <div class="bg-white rounded-lg p-6 mb-6 border border-gray-200">
              <div class="flex items-center gap-3">
                <svg class="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                  />
                </svg>
                <div class="flex-1">
                  <!-- Estado: Cargando -->
                  <div *ngIf="cargandoArchivo" class="flex items-center gap-2">
                    <svg
                      class="animate-spin h-5 w-5 text-purple-600"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    <p class="font-semibold text-gray-800">Cargando PDF...</p>
                  </div>

                  <!-- Estado: Archivo listo -->
                  <p *ngIf="!cargandoArchivo && archivoSeleccionado" class="font-semibold text-gray-800">
                    {{ archivoSeleccionado.name }}
                  </p>

                  <!-- Estado: Sin archivo -->
                  <p *ngIf="!cargandoArchivo && !archivoSeleccionado" class="font-semibold text-gray-800 text-red-600">
                    ⚠️ Sin archivo seleccionado
                  </p>

                  <p class="text-xs text-gray-500 mt-1">PDF de laboratorio</p>
                </div>
              </div>
            </div>

            <div class="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <p class="text-sm font-medium text-blue-800 mb-2">🔬 El análisis extraerá automáticamente:</p>
              <ul class="text-xs text-blue-700 space-y-1 ml-4">
                <li>• Hemoglobina, Hematocrito, Leucocitos y más</li>
                <li>• Comparación con rangos normales por edad y género</li>
                <li>• Detección automática de valores fuera de rango</li>
                <li>• Historial de estudios anteriores para ver tendencias</li>
              </ul>
            </div>

            <button
              type="button"
              class="w-full px-6 py-4 rounded-lg text-base font-bold bg-[#AE91E3] text-white hover:bg-[#9b7cd1] transition-all transform hover:scale-105 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
              (click)="iniciarAnalisisLaboratorio()"
              [disabled]="!archivoSeleccionado || cargandoArchivo"
            >
              <span class="flex items-center justify-center gap-2">
                <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
                  />
                </svg>
                <span *ngIf="!cargandoArchivo">🔬 Analizar Laboratorio</span>
                <span *ngIf="cargandoArchivo">Cargando archivo...</span>
              </span>
            </button>

            <p class="text-xs text-center text-gray-500 mt-4" *ngIf="!archivoSeleccionado && !cargandoArchivo">
              ⚠️ El archivo PDF se está cargando automáticamente...
            </p>
          </div>
        </div>

        <!-- ESTADO 2: Modal Analizando -->
        <app-analizador-laboratorio
          [archivo]="archivoSeleccionado!"
          [categoria]="'hematologia'"
          [appointmentId]="appointmentId!"
          [paraclinicoUuid]="paraclinicoSeleccionado.id!"
          (resultadosExtraidos)="onResultadosExtraidos($event)"
        ></app-analizador-laboratorio>

        <!-- ESTADO 3: Tabla Editable -->
        <div *ngIf="mostrarTablaResultados" class="tabla-resultados-container">
          <app-tabla-resultados-laboratorio
            [resultados]="resultadosExtraidos"
            [parametrosCatalogo]="parametrosCatalogo"
            [editable]="true"
            (guardar)="guardarResultadosLaboratorio($event)"
            (cancelar)="cancelarResultados()"
          ></app-tabla-resultados-laboratorio>
        </div>

        <!-- ESTADO 4: Histórico -->
        <div *ngIf="deberMostrarHistorico" class="historico-container">
          <div class="mb-4 flex justify-between items-center">
            <h3 class="text-lg font-bold text-gray-800">📊 Histórico de Laboratorios</h3>
            <button
              type="button"
              class="px-4 py-2 rounded-lg text-sm font-semibold bg-[#AE91E3] text-white hover:bg-[#9b7cd1] transition"
              (click)="agregarNuevoAnalisis()"
            >
              <span class="flex items-center gap-2">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
                </svg>
                Nuevo Análisis
              </span>
            </button>
          </div>

          <app-historico-laboratorio
            [pacienteId]="patientId!"
            [categoria]="'hematologia'"
            [useMockData]="false"
          ></app-historico-laboratorio>
        </div>
      </div>
    </div>
  </div>
</div>
